import { UiSettings } from "src/app/backend/models/settings/ui-settings";

export const PAGE_DETAIL_VERTICAL_TABS_ENABLED = false;

export function resolvePageDetailCompactToolbar(
  uiSettings?: UiSettings | null
): boolean {
  if (uiSettings?.pageDetailCompactToolbar !== undefined) {
    return uiSettings.pageDetailCompactToolbar;
  }

  return uiSettings?.pageDetailVerticalTabs ?? true;
}
